export const TYPE_TO_LABEL_MAP = {
  persistent: "Persistent",
  geo: "Geo",
  fulltext: "Fulltext",
  ttl: "TTL",
  zkd: "MDI",
  mdi: "MDI",
  "mdi-prefixed": "MDI (Prefixed)",
  inverted: "Inverted",
  tier: "Tier",
  primary: "Primary",
  edge: "Edge"
};
